//App
import { EmailTemplateContextData, TemplateEmailProps } from "../../../../types/template";
import useForm from "../../../hooks/useForm";
import { TemplateEmailContext } from "../TemplateEmailContainer";


const useTemplate = (props: TemplateEmailProps) => {
  return useForm<EmailTemplateContextData, TemplateEmailProps>(
    TemplateEmailContext,
    props
  );
};

export default useTemplate;
